import z from "zod";

export const schema = z
	.object({
		password: z.string().min(8, "Password is required"),
		passwordConfirmation: z
			.string()
			.min(8, "Password confirmation is required"),
	})
	.refine((data) => data.password === data.passwordConfirmation, {
		message: "Passwords do not match",
		path: ["passwordConfirmation"],
	});

export type Schema = z.infer<typeof schema>;
